import React from 'react';
import styles from '../../Css/PrivacyPolicy.module.css';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    privacyPolicy: {
        fontFamily: 'Arial, sans-serif',
        margin: theme.spacing(2),
        padding: theme.spacing(2),
        border: '1px solid #ccc',
        borderRadius: '5px',
        backgroundColor: '#f9f9f9',
    },
    privacyContainer: {
        maxWidth: '800px',
        margin: '0 auto',
        padding: '20px',
        fontFamily: 'Arial, sans-serif',
        lineHeight: '1.6',
      },
    sectionTitle: {
        fontSize: '24px',
        marginBottom: '10px',
        borderBottom: '1px solid #ccc',
        paddingBottom: '5px',
    },
    sectionContent: {
        fontSize: '16px',
        marginBottom: '20px',
    },
}));

const PrivacyPolicy = () => {
    const classes = useStyles();
    return (
        <div className={classes.privacyContainer}>
            <h2>Privacy Policy</h2>
            <p>
                This Privacy Policy outlines how Trending Data Hub collects, uses, and protects user information.
            </p>

            <div>
                <h3 className={classes.sectionTitle}>1. Information Collection</h3>
                <p className={classes.sectionContent}>
                    Trending Data Hub collects personal information such as name, email, and location when users voluntarily provide it for newsletter subscriptions, account creation, or commenting purposes. Additionally, we gather anonymous usage data through cookies and similar technologies to improve user experience and analyze website traffic.
                </p>
            </div>
            <div>
                <h3 className={classes.sectionTitle}>2. Information Usage</h3>
                <p className={classes.sectionContent}>
                    The collected information is used to personalize user experience, deliver tailored content based on user preferences and browsing behavior, and to send periodic emails related to website updates, featured articles, or promotional offers. It may also be used for internal research and analytics to improve our services.
                </p>
            </div>

            <div>
                <h3 className={classes.sectionTitle}>3. Data Sharing</h3>
                <p className={classes.sectionContent}>
                    Trending Data Hub does not sell, trade, or transfer personally identifiable information to third parties without user consent. However, non-personally identifiable visitor information may be shared with trusted third parties for analytics, advertising, or other purposes.
                </p>
            </div>

            <div>

                <h3 className={classes.sectionTitle}>4. Data Security</h3>
                <p className={classes.sectionContent}>
                    We implement security measures to safeguard user information. This includes encryption, access controls, and regular security audits. However, it's important to note that no method of transmission over the internet or electronic storage is 100% secure. Users share information at their own risk.
                </p>
            </div>

            <div>
                <h3 className={classes.sectionTitle}>5. User Rights</h3>
                <p className={classes.sectionContent}>
                    Users have the right to access, modify, or delete their personal information provided on the website. They can unsubscribe from newsletters or delete their accounts at any time.
                </p>
            </div>

            <div>
                <h3 className={classes.sectionTitle}>6. Children's Privacy</h3>
                <p className={classes.sectionContent}>
                    Trending Data Hub does not knowingly collect personal information from children under the age of 13. If you are a parent or guardian and believe that your child has provided us with personal information, please contact us to remove it.
                </p>
            </div>


            {/* Include more sections relevant to your specific data handling practices */}
        </div>
    );
};
export default PrivacyPolicy;
